/* eslint-disable @typescript-eslint/ban-ts-comment */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-nocheck
import { isEmpty } from '@/helpers/string.helpers'
import { MessageModel } from '@/models/message.model'
import { t } from 'i18next'

// TODO: Refactor this
export function getMessageText(message: MessageModel) {
  if (isEmpty(message)) return ''
  if (!isEmpty(message?.file?.type)) return getMessageType(message)
  if (message?.contactsMessage?.length) return t('translation:contact')
  if (!isEmpty(message.location)) return t('translation:location')
  if (!isEmpty(message.audio)) return t('translation:audio')
  if (!isEmpty(message.image)) return t('translation:image')
  if (!isEmpty(message.video)) return t('translation:video')
  if (!isEmpty(message.document)) return t('translation:document')
}

// TODO: Refactor this
export function getMessageType(message: MessageModel) {
  if (!message?.file?.type) return 'unknown'

  const [type] = message.file.type.split('/')

  switch (type) {
    case 'audio':
      return 'Audio'
    case 'file':
      return 'Arquivo'
    case 'video':
      return 'Video'
    case 'application':
      return 'Documento'
    default:
      return 'Imagem'
  }
}
